//
// 公共接口

import request from '@/utils/request'

// 添加收藏
export function AddToMyFavorite(data) {
  return request({
    url: 'MyFavorite/AddToMyFavorite',
    method: 'post',
    data: data
  })
}
// 获取收藏列表
export function GetMyFavorites(data) {
  return request({
    url: 'MyFavorite/GetMyFavorites',
    method: 'get',
    params: data
  })
}
// 删除收藏
export function DeleteFromMyFavorite(data) {
  return request({
    url: 'MyFavorite/DeleteFromMyFavorite',
    method: 'post',
    data: data
  })
}

// 通过code_type获取对应的base list
export function GetBaseDataByCodetype(data) {
  return request({
    url: 'ApiCommon/GetBaseDataByCodetype',
    method: 'get',
    params: data
  })
}

// 多个code_type获取对应的base list
export function GetBaseData(data) {
  return request({
    url: 'ApiCommon/GetBaseData',
    method: 'get',
    params: data
  })
}

// 多个code_type，返回int类型
export function GetBaseDataInt(data) {
  return request({
    url: 'ApiCommon/GetBaseDataInt',
    method: 'get',
    params: data
  })
}

// 单个code_type，返回int类型
export function GetBaseDataByCodetypeInt(data) {
  return request({
    url: 'ApiCommon/GetBaseDataByCodetypeInt',
    method: 'get',
    params: data
  })
}

// 通过code_type获取对应的base list
export function GetBaseDataByEsignCodetype(data) {
  return request({
    url: 'ESign/GetBaseDataByEsignCodetype',
    method: 'get',
    params: data
  })
}
// 分销下单 银行账户
export function GetBankAccountListByApplicationType(data) {
  return request({
    url: 'ApiCommon/GetBankAccountListByApplicationType',
    method: 'get',
    params: data
  })
}

// 分销下单快递
export function GetOakShopLogisticsTypeList(data) {
  return request({
    url: 'ApiCommon/GetOakShopLogisticsTypeList',
    method: 'get',
    params: data
  })
}

// 分销物流信息
export function GetOakShopLogisticsList(data) {
  return request({
    url: 'ApiCommon/GetOakShopLogisticsList',
    method: 'get',
    params: data
  })
}

// 获取用户列表
export function GetUserList(data) {
  return request({
    url: 'ApiCommon/GetUserList',
    method: 'get',
    params: data
  })
}

// 获取店铺列表
export function GetShopList(data) {
  return request({
    url: 'ApiCommon/GetShopList',
    method: 'get',
    params: data
  })
}

// 获取用户可用店铺
export function GetShopByUser(data) {
  return request({
    url: 'ApiCommon/GetShopByUser',
    method: 'get',
    params: data
  })
}

// 获取红人结算可用店铺
export function GetShopByClearingShop(data) {
  return request({
    url: 'ApiCommon/GetShopByClearingShop',
    method: 'get',
    params: data
  })
}
// 获取地址三联
export function GetRegionList(data) {
  return request({
    url: 'ApiCommon/GetRegionList',
    method: 'get',
    params: data
  })
}

// 根据名称获取地址三联
export function GetRegionListByName(data) {
  return request({
    url: 'ApiCommon/GetRegionListByName',
    method: 'get',
    params: data
  })
}

// 获取仓库列表
export function GetWarehouseList(data) {
  return request({
    url: 'ApiCommon/GetWarehouseList',
    method: 'get',
    params: data
  })
}

// 获取物流列表
export function GetLogisticsInfoList(data) {
  return request({
    url: 'ApiCommon/GetLogisticsInfoList',
    method: 'get',
    params: data
  })
}

// 获取品牌
export function GetBrandList(data) {
  return request({
    url: 'ApiCommon/GetBrandList',
    method: 'get',
    params: data
  })
}

// 获取总代品牌
export function GetInternalBrandList(data) {
  return request({
    url: 'ApiCommon/GetInternalBrandList',
    method: 'get',
    params: data
  })
}

// 获取海关国家（地区）列表
export function GetCountryOrRegionList(data) {
  return request({
    url: 'ApiCommon/GetCountryOrRegionList',
    method: 'get',
    params: data
  })
}

export function GetGoodsClassName(data) {
  return request({
    url: 'ApiCommon/GetGoodsClassName',
    method: 'get',
    params: data
  })
}
// 获取国家列表
export function GetCountryList(data) {
  return request({
    url: 'ApiCommon/GetCountryList',
    method: 'get',
    params: data
  })
}
// 获取代发账户
export function GetAgencyAccount(data) {
  return request({
    url: 'ApiCommon/GetAgencyAccount',
    method: 'get',
    params: data
  })
}
// 获取代发账户
export function GetBaseDataByCondition(data) {
  return request({
    url: 'ApiCommon/GetBaseDataByCondition',
    method: 'get',
    params: data
  })
}
// 获取供应商列表
export function SupplierList(data) {
  return request({
    url: 'ApiCommon/SupplierList',
    method: 'get',
    params: data
  })
}

// 获取供应商列表
export function GetSupplierList(data) {
  return request({
    url: 'Supplier/GetSupplierList',
    method: 'get',
    params: data
  })
}

// 根据品牌找商品
export function GetSkuByBrand(data) {
  return request({
    url: 'ApiCommon/GetSkuByBrand?brand=' + data,
    method: 'get'

  })
}
// 获取公司列表
export function GetCustomerCompanyList(data) {
  return request({
    url: 'ApiCommon/GetCustomerCompanyList',
    method: 'get'

  })
}
// 获取客户列表
export function GetFxCustomerList(data) {
  return request({
    url: 'ApiCommon/GetFxCustomerList',
    method: 'get'

  })
}

// 获取合同账户
export function GetAgencyContractCustList(data) {
  return request({
    url: 'ApiCommon/GetAgencyContractCustList',
    method: 'get'

  })
}
// 根据账户号获取仓库list
export function GetSelfWarehouseListByAccount(data) {
  return request({
    url: 'ApiCommon/GetSelfWarehouseListByAccount',
    method: 'get',
    params: data
  })
}
// 获取承运商
export function GetLogisticsCompanyList(data) {
  return request({
    url: 'ApiCommon/GetLogisticsCompanyList',
    method: 'get',
    params: data
  })
}
//! 广告结算系统对接人/执行人
export function GetAdsTransactor(data) {
  return request({
    url: 'ApiCommon/GetAdsTransactor',
    method: 'get',
    params: data
  })
}

// 根据币种获取汇率
export function GetCurrencyFinanceRate(data) {
  return request({
    url: 'ApiCommon/GetCurrencyFinanceRate',
    method: 'get',
    params: data
  })
}
//! 广告结算系统红人远程模糊搜索
export function GetCelebrityByCondition(data) {
  return request({
    url: 'ApiCommon/GetCelebrityByCondition',
    method: 'get',
    params: data
  })
}
//! 广告主代理方
export function GetAdsAgency(data) {
  return request({
    url: 'ApiCommon/GetAdsAgency',
    method: 'get',
    params: data
  })
}
//! 广告结算收款方
export function GetHongrenOrgListByHrid(data) {
  return request({
    url: 'ApiCommon/GetHongrenOrgListByHrid',
    method: 'get',
    params: data
  })
}
//! 广告结算收款账号
export function GetOrgBankAccountList(data) {
  return request({
    url: 'ApiCommon/GetOrgBankAccountList',
    method: 'get',
    params: data
  })
}
//! 根据采购单号获取入库单号
export function GetStockinOrderByPurchaseNo(data) {
  return request({
    url: 'ApiCommon/GetStockinOrderByPurchaseNo',
    method: 'get',
    params: data
  })
}
// 获取部门
export function GetUserDingDept(data) {
  return request({
    url: 'ApiCommon/GetUserDingDept',
    method: 'get',
    params: data
  })
}
//! 大小运费根据change接口请求相关值
export function GetBankAccountInfo(data) {
  return request({
    url: 'ApiCommon/GetBankAccountInfo',
    method: 'get',
    params: data
  })
}

// 获取所有分销业务员
export function GetSalesmanUserList(data) {
  return request({
    url: 'ApiCommon/GetSalesmanUserList',
    method: 'get',
    params: data
  })
}
//! 广告结算收款方
export function GetHongrenOrgList(data) {
  return request({
    url: 'ApiCommon/GetHongrenOrgList',
    method: 'get',
    params: data
  })
}

// 短连接批量转长连接
export function MultipleShortToLongUrl(data) {
  return request({
    url: 'OakCommon/MultipleShortToLongUrl',
    method: 'get',
    params: data
  })
}

// 获取仓库list
export function GetIndependentWarehouseList(data) {
  return request({
    url: 'ApiCommon/GetIndependentWarehouseList',
    method: 'get',
    params: data
  })
}

// 获取合同list
export function GetContractListByNo(data) {
  return request({
    url: 'ApiCommon/GetContractListByNo',
    method: 'get',
    params: data
  })
}
// 获取c店成本商品
export function GetProductInfoByCondition(data) {
  return request({
    url: 'ApiCommon/GetProductInfoByCondition',
    method: 'get',
    params: data
  })
}
export function GetCurrencyRate(data) {
  return request({
    url: 'ApiCommon/GetCurrencyRate',
    method: 'get',
    params: data
  })
}
export function GetCurrencyRateByCode(data) {
  return request({
    url: 'ApiCommon/GetCurrencyRateByCode',
    method: 'get',
    params: data
  })
}

// 获取单位列表
export function GetUomList(data) {
  return request({
    url: 'ApiCommon/GetUomList',
    method: 'get',
    params: data
  })
}

// 获取保宏仓库列表
export function GetBaoHongWarehouseList(data) {
  return request({
    url: 'ApiCommon/GetBaoHongWarehouseList',
    method: 'get',
    params: data
  })
}
// 获取nc仓库
export function GetNcwarehouseList(data) {
  return request({
    url: 'Summary/GetNcwarehouseList',
    method: 'get',
    params: data
  })
}
// 保存审批流评论
export function SaveComment(data) {
  return request({
    url: 'approve/JJFlowComment/SaveComment',
    method: 'post',
    data: data
  })
}
// 获取审批流评论列表
export function GetComments(data) {
  return request({
    url: 'approve/JJFlowComment/GetComments',
    method: 'get',
    params: data
  })
}
// 获取审批流轨迹 jjflow
export function GetFlowTrackList(data) {
  return request({
    url: 'approve/JJFlow/GetFlowTrackList',
    method: 'get',
    params: data
  })
}
// 获取审批流节点列表
export function GetCompletedNodeList(data) {
  return request({
    url: 'approve/JJFlow/GetCompletedNodeList',
    method: 'get',
    params: data
  })
}
// 退回到某一节点
export function SendBack(data) {
  return request({
    url: 'approve/JJFlow/SendBack',
    method: 'post',
    data: data
  })
}
// 新增查阅日志
export function ViewLog(data) {
  return request({
    url: 'approve/JJFlow/ViewLog',
    method: 'get',
    params: data
  })
}
// 查询查阅日志
export function GetViewedLog(data) {
  return request({
    url: 'approve/JJFlow/GetViewedLog',
    method: 'get',
    params: data
  })
}
// 获取采购单/调拨单仓库列表
export function GetWarehouseListByWarehouseCode(data) {
  return request({
    url: 'ApiCommon/GetWarehouseListByWarehouseCode',
    method: 'get',
    params: data
  })
}
// 获取仓库列表
export function TempGetWarehouseList(data) {
  return request({
    url: 'ApiCommon/TempGetWarehouseList',
    method: 'get',
    params: data
  })
}

// 获取审批流轨迹 jjflow
export function ReadLog(data) {
  return request({
    url: 'approve/JJFlow/ReadLog',
    method: 'get',
    params: data
  })
}

// 获取当前人在当前业务模块是否有审核权限 用以在列表中判断是否将活动状态或审核状态设置为待我审核
// / 查询 待我审批参数
// / 系统key
// public string system_key { get; set; }

// / 大模块key
// public string big_modular_key { get; set; }

// / 前端模块key
// public string modular_key { get; set; }

// / 当前用户
// public int user_id { get; set; }

export function GetUserPower(data) {
  return request({
    url: 'approve/JJFlow/GetUserPower',
    method: 'get',
    params: data
  })
}
// 新增base
export function AddBaseType(data) {
  return request({
    url: 'ErpaBase/AddBaseType',
    method: 'post',
    data
  })
}

// 获取当前仓库是否是保税仓
export function IsBondedZone(data) {
  return request({
    url: 'ApiCommon/IsBondedZone',
    method: 'get',
    params: data
  })
}

// 红人签约公司
export function GetCelebrityCompanyList(data) {
  return request({
    url: 'ApiCommon/GetCelebrityCompanyList',
    method: 'get',
    params: data
  })
}
// 获取审批部门
export function GetCurrentUserDeptLink(data) {
  return request({
    url: 'ApiCommon/GetCurrentUserDeptLink',
    method: 'get',
    params: data
  })
}

// 获取当前用户审批权限
export function CheckUserPower(data) {
  return request({
    url: 'approve/JJFlow/CheckUserPower',
    method: 'get',
    params: data
  })
}

export function GetAgencyAccountNoDisable(data) {
  return request({
    url: 'ApiCommon/GetAgencyAccountNoDisable',
    method: 'get',
    params: data
  })
}

export function GetDFCompanyList(data) {
  return request({
    url: 'ApiCommon/GetDFCompanyList',
    method: 'get',
    params: data
  })
}

//   获取公司list
export function GetErpaOrgBaseList(data) {
  return request({
    url: 'ErpaOrganization/GetErpaOrgBaseList',
    method: 'get',
    params: data
  })
}

//  获取部门层级所有id (包含自己部门)
export function GetPartmentDepartmentIds(data) {
  return request({
    url: 'erp/Department/GetPartmentDepartmentIds',
    method: 'get',
    params: data
  })
}

